var _circle, _circle2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 8,
    cy: 8,
    r: 8,
    transform: "rotate(180 8 8)",
    fill: "#1D4FAF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 7.99908,
    cy: 7.99909,
    r: 5.82123,
    transform: "rotate(180 7.99908 7.99909)",
    fill: "#1D4FAF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.99918,
    cy: 7.99918,
    rx: 4.85043,
    ry: 4.85043,
    transform: "rotate(180 7.99918 7.99918)",
    fill: "#1D4FAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPoints);
export default __webpack_public_path__ + "static/media/EditPoints.48ae3fd54ee608f2e055771530d12b66.svg";
export { ForwardRef as ReactComponent };